import { Platform, Status } from "./enums";
import johnDeereOpsCenterLogo from "@/assets/images/JDOC-tm-default.svg";
import caseIhLogo from "@/assets/images/CaseNewHolland_CombinedLogos.png";
import fieldnetLogo from "@/assets/images/fieldnet-logo.svg";
import climateFieldviewLogo from "@/assets/images/Climate_FieldView_Horizontal_thumb.svg";

export type Connection = {
    id: number;
    platform: Platform;
    status: Status;
};

export type UserConnection = {
    id: number;
    user: number;
    username: string;
    connection: number | Platform;
    platform: Platform;
    action_required: boolean;
};

export type FieldConnection = {
    id: number;
    field: number;
    status: string;
    platform_field_name: string;
    user_connection: UserConnection;
    platform_field_id: string;
};

export type IrrigationSystemConnection = {
    id: number;
    irrigation_system: number;
    status: string;
    platform_irrigation_system_name: string;
    user_connection: UserConnection;
    platform_irrigation_system_id: string;
};

export const PLATFORM_LOGOS: Record<Platform, string> = {
    [Platform.JohnDeere]: johnDeereOpsCenterLogo,
    [Platform.CNHI]: caseIhLogo,
    [Platform.FieldView]:
        climateFieldviewLogo,
    [Platform.FieldNET]: fieldnetLogo,
};

export type LeafField = {
    id: string;
    leafUserId: string;
    boundaries: string[];
    providerName: string;
    providerFieldId: string;
    providerBoundaryId: string;
    providerFieldName: string;
    providerFarmName: string;
    linked: boolean;
    providerGrowerName?: string;
    name?: string;
};
